// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zbLl","top":"styles_top__1R1a5","left":"styles_left__zpt09","description":"styles_description__zj3go"};